import { useTranslation } from "react-i18next";
import { DEFAULT_NOTE_TYPES, NOTE_STATUS } from "@/services/api";
import type { MenuFilter } from "@/common/MenuFilter";

export const useDefaultFilterMenuOptions = () => {
  const { t } = useTranslation();
  const getDefaultPersonGroupOptions = (): MenuFilter[] => {
    return [
      { label: t("contactsPage.groups.family"), value: "FAMILY" },
      { label: t("contactsPage.groups.friends"), value: "FRIENDS" },
      { label: t("contactsPage.groups.colleagues"), value: "COLLEAGUES" },
      { label: t("contactsPage.groups.business"), value: "BUSINESS" },
      { label: t("contactsPage.groups.other"), value: "OTHER" },
    ];
  };

  const getDefaultDirectionOptions = (): MenuFilter[] => {
    return [
      { label: t("notesPage.outgoing"), value: "OUTGOING" },
      { label: t("notesPage.incoming"), value: "INCOMING" },
    ];
  };

  const getDefaultNoteStatusOptions = (): MenuFilter[] => {
    return [
      {
        label: t("common.status.toDo"),
        value: NOTE_STATUS.TO_DO,
      },
      {
        label: t("common.status.inProgress"),
        value: NOTE_STATUS.IN_PROGRESS,
      },
      {
        label: t("common.status.done"),
        value: NOTE_STATUS.DONE,
      },
    ];
  };

  const getDefaultNoteTypeOptions = (): MenuFilter[] => {
    return [
      {
        label: t("common.noteType.note", { count: 1 }),
        value: DEFAULT_NOTE_TYPES.DEFAULT_NOTE,
      },
      {
        label: t("common.noteType.idea", { count: 1 }),
        value: DEFAULT_NOTE_TYPES.DEFAULT_IDEA,
      },
      {
        label: t("common.noteType.meeting", { count: 1 }),
        value: DEFAULT_NOTE_TYPES.DEFAULT_MEETING,
      },
      {
        label: t("common.noteType.lifeStory", { count: 1 }),
        value: DEFAULT_NOTE_TYPES.DEFAULT_LIFE_STORY,
      },
      {
        label: t("common.noteType.commitment", { count: 1 }),
        value: DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT,
      },
    ];
  };
  return {
    getDefaultPersonGroupOptions,
    getDefaultNoteTypeOptions,
    getDefaultNoteStatusOptions,
    getDefaultDirectionOptions,
  };
};
